module.exports = __webpack_public_path__ + "static/logo-b42d06456ccf5ac31fa3a988bc0052d9.png";